<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="8" :sm="12">
            <a-form-item label="保险公司">
              <j-search-select-tag
                placeholder="请选择保险公司"
                v-model="queryParam.insurerNumber"
                dict="biz_insurance_company,name,code">
              </j-search-select-tag>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="6">
            <a-form-item label="被保人">
              <a-input placeholder="请录入被保险人" v-model="queryParam.insured"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item label="项目名称">
              <j-dict-select-tag type="list" v-model="queryParam.project" dictCode="bms_project" placeholder="请选择项目"/>
            </a-form-item>
          </a-col>

          <!--<a-col :md="4" :sm="6">-->
            <!--<a-form-item label="车牌号" >-->
              <!--<a-input v-model="queryParam.car" placeholder="请输入车牌号"></a-input>-->
            <!--</a-form-item>-->
          <!--</a-col>-->

          <template v-if="toggleSearchStatus">
            <a-col :md="4" :sm="6">
              <a-form-item label="业务类型">
                <j-dict-select-tag
                  placeholder="请选择业务类型"
                  v-model="queryParam.businessType"
                  :options="newBusinessTypeDictOptions">
                </j-dict-select-tag>
              </a-form-item>
            </a-col>
            <!--<a-col :md="4" :sm="6">-->
              <!--<a-form-item label="投保人">-->
                <!--<a-input placeholder="请录入投保人" v-model="queryParam.insure"/>-->
              <!--</a-form-item>-->
            <!--</a-col>-->
            <a-col :md="4" :sm="8">
              <a-form-item label="经纪人">
                <j-search-select-tag
                  placeholder="请选择经纪人"
                  v-model="queryParam.createBy"
                  dict="sys_user,realname,username,del_flag=0">
                </j-search-select-tag>
              </a-form-item>
            </a-col>
            <!--<a-col :md="4" :sm="8">-->
              <!--<a-form-item label="提交日期">-->
                <!--<j-date placeholder="请选择" v-model="queryParam.commitAuditDate"/>-->
              <!--</a-form-item>-->
            <!--</a-col>-->
            <!--<a-col :md="6" :sm="6">-->
              <!--<a-form-item label="险种名称">-->
                <!--<a-input placeholder="请录入险种名称" v-model="queryParam.insuranceName"/>-->
              <!--</a-form-item>-->
            <!--</a-col>-->
            <a-col :md="6" :sm="6">
              <a-form-item label="保单号" >
                <a-input v-model="queryParam.policy" placeholder="请输入保单号"></a-input>
              </a-form-item>
            </a-col>
          </template>

          <a-col :md="4" :sm="10">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="batchInvoice" icon="reload" style="margin-left: 8px" v-has="'businessInfoDoInvoice:doInvoice'">开票</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
        <span style="margin-left: 60px" >金额单位：元</span>
        <span style="margin-left: 24px" >保费合计：{{premiumTotal}}</span>
        <span style="margin-left: 24px" >去税保费合计：{{cleanPremiumTotal}}</span>
        <span style="margin-left: 24px" >总佣金合计：{{brokerageTotal}}</span>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>
        <template slot="statusSlot" slot-scope="text, record">
          <span>{{getStatus(record)}}</span>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">详情</a>
          <a-divider type="vertical"/>
          <a v-if="record.status==12" v-has="'businessInfoDoInvoice:invoice'" @click="handleInvoiceInfo(record)">发票</a>

          <!--<a-dropdown>-->
            <!--<a class="ant-dropdown-link">更多 <a-icon type="down" /></a>-->
            <!--<a-menu slot="overlay">-->
              <!--<a-menu-item v-if="record.status==12" >-->
                <!--<a v-has="'businessInfoDoInvoice:doInvoice'" @click="updateStatus(record)" >开票</a>-->
              <!--</a-menu-item>-->
            <!--</a-menu>-->
          <!--</a-dropdown>-->
        </span>

      </a-table>
    </div>

    <biz-businessinfo-complete-modal ref="modalForm" @ok="modalFormOk"></biz-businessinfo-complete-modal>

    <a-modal ref="invoiceModal" v-if="invoiceModalVisible" :visible.sync="invoiceModalVisible" title="发票信息" @ok="handleOk" @cancel="handleCancel">
      <biz-businessinfo-invoice-form :businessinfoId="businessinfoId">
      </biz-businessinfo-invoice-form>
    </a-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { filterObj } from '@/utils/util'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
  import {getAction, postAction} from '@/api/manage'
  import JDate from '@/components/jeecg/JDate'
  import BizBusinessinfoCompleteModal from './modules/BizBusinessinfoCompleteModal'
  import BizBusinessinfoInvoiceForm from './modules/BizBusinessinfoInvoiceForm'
  import { mapGetters } from 'vuex'
  import { NewBusinessTypeDictOptions } from '../enums/businessTypeDictOptions'

  // 业绩状态 10补录中 11待审核 12 已审核
  const BMS_BUSINESS_STATUS_UNFIX = '10'
  const BMS_BUSINESS_STATUS_READY = '11'
  const BMS_BUSINESS_STATUS_PASS = '12'
  const BMS_BUSINESS_STATUS_INVOICED = '13'

  export default {
    name: 'BizBusinessinfoAuditList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      JSearchSelectTag,
      BizBusinessinfoCompleteModal,
      JDate,
      BizBusinessinfoInvoiceForm,
    },
    data () {
      return {
        description: '业绩审核列表',
        disableMixinCreated: true,
        invoiceModalVisible: false,
        newBusinessTypeDictOptions:[],
        businessinfoId: '',
        brokerageTotal: 0.0, // 合计
        cleanPremiumTotal: 0.0,
        premiumTotal: 0.0,
        isorter:{
          column: 'createTime',
          order: 'desc',
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'业绩编号',
            className:'column-text',
            dataIndex: 'businessNumber',
            sorter: true
          },
          {
            title:'业绩状态',
            align:"center",
            scopedSlots: { customRender: 'statusSlot' }
          },
          {
            title:'业务类型',
            align:"center",
            dataIndex: 'businessType_dictText'
          },
          {
            title:'标的类型',
            align:"center",
            dataIndex: 'productOrLife_dictText'
          },
          /*{
            title:'业绩类型',
            align:"center",
            dataIndex: 'businessPerformanceType_dictText'
          },*/
          {
            title:'项目',
            className:"column-text",
            dataIndex: 'project_dictText'
          },
          {
            title:'经纪人',
            align:"center",
            dataIndex: 'createBy_dictText',
            sorter: true
          },
          {
            title:'部门',
            className:"column-text",
            dataIndex: 'sysOrgCode_dictText',
            sorter: true
          },
          {
            title:'投保人',
            className:"column-text",
            dataIndex: 'insure'
          },
          {
            title:'被保险人',
            className:"column-text",
            dataIndex: 'insured'
          },
          {
            title:'保险人',
            className:"column-text",
            dataIndex: 'insurerNumber_dictText'
          },
          {
            title:'险种类型',
            className:"column-text",
            dataIndex: 'insuranceType_dictText'
          },
          {
            title:'险种名称',
            className:"column-text",
            dataIndex: 'insuranceName'
          },
          {
            title:'车牌号',
            className:'column-text',
            dataIndex: 'car'
          },
          {
            title:'保险起期',
            className:"column-text",
            dataIndex: 'insuranceStart',
            sorter: true,
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title:'保险讫期',
            className:'column-text',
            dataIndex: 'insuranceEnd',
            sorter: true,
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title:'保单号',
            className:'column-text',
            dataIndex: 'policy',
            sorter: true
          },
          {
            title:'保额',
            className:'column-money',
            dataIndex: 'insuredAmount',
            customRender:function (text) {
              return !text ? '': text.toLocaleString()
            }
          },
          {
            title:'费率',
            className:'column-money',
            dataIndex: 'rate',
            customRender:function (text) {
              return !text ? '': text + '‰'
            }
          },
          {
            title:'保费',
            className:'column-money',
            dataIndex: 'premium',
            customRender:function (text) {
              return !text ? '': text.toLocaleString()
            }
          },
          {
            title:'去税保费',
            className:'column-money',
            dataIndex: 'cleanPremium',
            customRender:function (text) {
              return !text ? '': text.toLocaleString()
            }
          },
          {
            title:'是否含税',
            align:"center",
            dataIndex: 'includeTax_dictText'
          },
          {
            title:'缴费类型',
            align:"center",
            dataIndex: 'lifeInsurancePayType_dictText'
          },
          {
            title:'佣金比例',
            className:'column-money',
            dataIndex: 'brokerageRatio',
            customRender:function (text) {
              return text == null? '': text + '%'
            }
          },
          {
            title:'总佣金',
            className:'column-money',
            dataIndex: 'brokerageTotal',
            customRender:function (text) {
              return !text ? '': text.toLocaleString()
            }
          },
          // {
          //   title:'开票比例',
          //   className:'column-money',
          //   dataIndex: 'invoiceRatio',
          //   customRender:function (text) {
          //     return text == null ? '': text + '%'
          //   }
          // },
          {
            title:'票外金额',
            //align:"center",
            className:'column-money',
            dataIndex: 'outsideInvoiceAmount',
            customRender:function (text) {
              return !text ? '': text.toLocaleString()
            }
          },
          // V6
          {
            title:'开票编号',
            className:'column-text',
            dataIndex: 'invoiceNumber'
          },
          {
            title:'开票日期',
            className:'column-text',
            dataIndex: 'invoiceTime',
            sorter: true
          },
          {
            title:'开票单位', //九安、 九安分公司
            className:'column-text',
            dataIndex: 'invoiceUnit_dictText',
          },
          {
            title:'期数',
            align:"center",
            dataIndex: 'phase'
          },
/*          {
            title:'合作机构',
            className:'column-text',
            dataIndex: 'institution_dictText'
          },*/
          {
            title:'区域',
            className:'column-text',
            dataIndex: 'zone'
          },
          {
            title:'创建日期',
            className:'column-text',
            dataIndex: 'createTime'
          },
          {
            title:'协议附件',
            align:"center",
            dataIndex: 'file',
            scopedSlots: {customRender: 'fileSlot'}
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:120,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/bms/bizBusinessinfoComplete/list",
          getMoneyTotal: '/bms/bizBusinessinfoComplete/getMoneyTotal', // 查询合计数
          invoice: '/bms/bizBusinessinfoComplete/batchInvoice', // 开票
        },
      }
    },
    created() {
      this.newBusinessTypeDictOptions = NewBusinessTypeDictOptions
      //改变页大小成员改变
      this.ipagination.pageSizeOptions = ['5','10', '20', '100']
    },
    methods: {
      ...mapGetters(["userInfo"]),
      initDictConfig(){
      },
      handleInvoiceInfo(record){
        this.businessinfoId = record.id
        this.invoiceModalVisible = true
      },
      getStatus(record){
        if(record.status == BMS_BUSINESS_STATUS_UNFIX){
          return "补录中"
        } else if(record.status == BMS_BUSINESS_STATUS_READY){
          return "待审核"
        } else if(record.status == BMS_BUSINESS_STATUS_PASS){
          return "已审核"
        } else if(record.status == BMS_BUSINESS_STATUS_INVOICED){
          return "已开票"
        }
      },

      getQueryParams() {
        /*if(!this.queryParam.insurerNumber || !this.queryParam.insured || !this.queryParam.project){
          this.$message.warning('保险公司、被保人、项目名称不能为空')
          return false;
        }*/

        //使用高级查询方式插入默认条件 1. status=12  数据库字段为varchar; 2. source='platform'
        let supQueryObj = [{rule:'eq', type:'string', val:BMS_BUSINESS_STATUS_PASS, field:'convert(status,unsigned)'},{
          rule:'eq', type:'string', val:'platform', field: 'source'}]
        let superQueryParams = JSON.stringify(supQueryObj);
        let sqp = {
          superQueryParams: encodeURI(superQueryParams),
          superQueryMatchType: 'and'
        }

        let param = Object.assign(sqp, this.queryParam, this.isorter ,this.filters)

        if(param.insured){
          param.insured = `*${param.insured.trim()}*` // 被保人模糊匹配
        }
        // if(param.insure){
        //   param.insure = `*${param.insure.trim()}*` // 投保人模糊匹配
        // }
        if(param.policy){
          param.policy = `*${param.policy.trim()}*` // 保单号模糊匹配
        }
        // if(param.insuranceName){
        //   param.insuranceName = `*${param.insuranceName.trim()}*` // 险种名称模糊匹配
        // }
        if(param.car){
          param.car = `*${param.car}*` // 车牌号模糊查询
        }
        // 导入日期
        if(param.createTime){
          param.createTime_begin = param.createTime + ' 00:00:00'
          param.createTime_end = param.createTime + ' 23:59:59'
          delete param.createTime
        }
        // //保险起期
        // if(param.insuranceStart){
        //   param.insuranceStart_begin = param.insuranceStart + ' 00:00:00'
        //   param.insuranceStart_end = param.insuranceStart + ' 23:59:59'
        //   delete param.insuranceStart
        // }
        //
        // if(param.insuranceEnd){
        //   param.insuranceEnd_begin = param.insuranceEnd + ' 00:00:00'
        //   param.insuranceEnd_end = param.insuranceEnd + ' 23:59:59'
        //   delete param.insuranceEnd
        // }
        // 开票日期
        // if(param.invoiceTime){
        //   param.invoiceTime_begin = param.invoiceTime + ' 00:00:00'
        //   param.invoiceTime_end = param.invoiceTime + ' 23:59:59'
        //   delete param.invoiceTime
        // }
        // 进度处理
        // if(param.progress){
        //   param.status = param.progress
        //   delete param.progress
        // }

        param.pageNo = this.ipagination.current
        param.pageSize = this.ipagination.pageSize
        return filterObj(param);
      },

      loadData(arg) {
        this.onClearSelected()
        if (arg == 1) {
          this.ipagination.current = 1
        }
        let params = this.getQueryParams();
        if(!params){
          return
        }

        this.loading = true
        getAction(this.url.list, params).then((res) => {
          if (res.success) {
            this.dataSource = res.result.records;
            this.ipagination.total = res.result.total;

            if(this.ipagination.current === 1){
              //删除排序条件
              delete params.column
              delete params.order
              //delete params.superQueryParams // status字段类型不对，后台sql重新拼写
              //delete params.superQueryMatchType
              getAction(this.url.getMoneyTotal, params).then((result)=>{
                if (result.success) {
                  this.brokerageTotal = !result.result.brokerageTotal ? '': result.result.brokerageTotal.toLocaleString()
                  this.cleanPremiumTotal = !result.result.cleanPremiumTotal ? '': result.result.cleanPremiumTotal.toLocaleString()
                  this.premiumTotal = !result.result.premiumTotal ? '': result.result.premiumTotal.toLocaleString()
                }
              })
            }
          }
          if(res.code===510){
            this.$message.warning(res.message)
          }
          this.loading = false;
        })
      },

      //单条更新状态,提交审核
      updateStatus(record){
        if(record === undefined || record === null){
          return
        }
        let param = {id: record.id, status: BMS_BUSINESS_STATUS_PASS}
        postAction(this.url.invoice, param).then((res) =>{
          if(res.success){
            this.$message.info(res.result)
            this.loadData()
          } else {
            this.$message.warn(res.message)
          }
        })
      },

      // 批量开票
      batchInvoice(){
        let params = this.getQueryParams();
        if(!params || this.dataSource.length <=0){
          return
        }

        if(this.selectedRowKeys.length <=0){ //未选择特定行，全部审核
          this.doBatchInvoice(this, params)
        } else {
          const that = this
          // 部分审核
          this.$confirm({
            title: '提示',
            content: '审核当前选择的'+ that.selectedRowKeys.length +'条业绩？',
            onOk() {
              that.doBatchInvoice(that, {idList: that.selectedRowKeys})
            },
            onCancel() {
            }
          });
        }
      },

      doBatchInvoice(that, params){
        postAction(that.url.invoice, params).then((res) =>{
          if(res.success){
            that.$message.info(res.result)
            that.loadData()
          } else {
            that.$message.warn(res.message)
          }
        })
      },

      handleCancel(){
        this.$nextTick(()=> {
          this.invoiceModalVisible = false
        })
      },

      handleOk(){
        this.$nextTick(()=> {
          this.invoiceModalVisible = false
        })
      },
    }
  }
</script>
<style>
  @import '~@assets/less/common.less';
  th.column-money {
    text-align: center !important;
  }
  td.column-money {
    text-align: right !important;
  }

  th.column-text {
    text-align: center !important;
  }
  td.column-text {
    text-align: left !important;
  }
</style>